export default function DonneeFiltreeUtilisateursConfiguration($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('donnee.filtree.utilisateurs');
}

DonneeFiltreeUtilisateursConfiguration.$inject = ['$translatePartialLoaderProvider'];
